export const REVIEW_STEP_FORM_ID = 'replaceMeterReviewStepForm';
